const register = {
  loginCredentials: "Login Credentials",
  companyInformation: "Company Information",
  contactDetails: "Contact Details",
  businessName: "Business Name",
  businessAddress: "Business Address",
  registrationCode: "Registration Code",
  businessRegistrationNumber: "Business Registration Number",
  websiteUrl: "Website URL",
  mobilePhone: "Mobile Phone",
  regionStateProvince: "Region/State/Province",
  legalTitle: "Legal Title",
  city: "City",
  postalCode: "Postal Code",
  registrationSuccess: "Registration Success.",
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Please wait a few moments and you will be redirected to the home page.",
  usernameEmail: "Username (Email)",
  password: "Password",
  verifyPassword: "Verify Password",
  documents: "Documents",
  termsAndConditionsSection: "Terms & Conditions",
  certificateOfIncorporation: "Certificate Of Incorporation",
  acceptTermsAndConditions: "Accept Terms & Conditions",
  country: "Country",
  brandName: "Brand Name",
  register: "Register",
  isRequired: "Is required",
  passwordMin8Chars: "Must have at least 8 characters",
  passwordRequiresDigit: "Must contain at least 1 digit",
  passwordRequiresLowercase: "Must contain at least 1 lowercase letter",
  passwordRequiresUppercase: "Must contain at least 1 uppercase letter",
  passwordRequiresSpecialChar: 'Must contain at least 1 special character(!@#$%^&*(),.?":{}|<>)',
  uploadFile: "Upload File",
  filename: "Filename:",
  fileType: "Type:",
  fileSize: "Size:",
  maxFileSize10Mb: "Max : 10MB",
  supportedFileTypes: "Supported file types:",
  showPassword: "Show password",
  hidePassword: "Hide password",
  notAvailable: "N/A",
  fileSizeInKb: "{{size}} KB",
  mobilePhonePlaceholder: "e.g. +12025550123",
  websiteUrlPlaceholder: "http://www.example.com",
  loading: "Loading...",
  uploadingDocument: "Uploading document...",
  percentUploaded: "{{percent}}% uploaded",
  registrationSuccessful: "Registration successful.",
  failedToUploadDocument: "Failed to upload document.",
  fieldIsRequired: "{{field}} {{isRequired}}",
  fieldMinLength: "{{field}} must be longer than {{min}} characters",
  fieldMustBeValidEmail: "{{field}} must be a valid email",
  fieldPasswordMinLength: "{{field}} must have at least 8 characters",
  fieldPasswordRequiresDigit: "{{field}} must contain at least 1 digit",
  fieldPasswordRequiresLowercase: "{{field}} must contain at least 1 lowercase letter",
  fieldPasswordRequiresUppercase: "{{field}} must contain at least 1 uppercase letter",
  fieldPasswordRequiresSpecialChar:
    '{{field}} must contain at least 1 special character (!@#$%^&*(),.?":{}|<>)',
  passwordsDoNotMatch: "{{field}} does not match {{otherField}}",
  fieldBetweenLength: "{{field}} must be between {{min}} and {{max}} characters",
  postalCodeBetweenLength: "{{field}} code must be between {{min}} and {{max}} characters",
  invalidUrlFormat: "Invalid URL format",
  invalidEmailFormat: "Invalid email format",
  emailMustMatchUsername: "email must be the same as username (email)",
  mobilePhoneIsRequired: "Mobile phone is required",
  certificateFileTooLarge: "Certificate File too large",
  termsMustBeAccepted: "Terms & Conditions must be accepted",
};

export default register;
